import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import GlobalGroupOffersSkeleton from '../components/GlobalGroupOffersSkeleton/GlobalGroupOffersSkeleton';
import * as constants from '../util/constants';
import helpers from '../util/helpers';

class AppGlobalGroupOffersPage extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      offersCount: '',
      allOffers: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.pageID = '';
    this.region = '';
    this.brand = '';
    this.firstLoad = 6;
    this.loadMore = 6;

    const searchGroupOffersForm = $('.search-group-offers');
    if (searchGroupOffersForm.length) {
      const offerRegionInput = searchGroupOffersForm.find('input.region-search');
      const offerBrandsInput = searchGroupOffersForm.find('input.brands-search');

      this.region = offerRegionInput.val();
      this.brand = offerBrandsInput.val();
    }

    const globalGroupOffersWrapper = $('#global-group-offers-wrapper');
    if (globalGroupOffersWrapper.length) {
      this.pageID = globalGroupOffersWrapper.data('page-id');
      this.firstLoad = globalGroupOffersWrapper.data('first-load');
      this.loadMore = globalGroupOffersWrapper.data('load-more');
    }

    // Bind "this"
    this.loadGlobalOffers = this.loadGlobalOffers.bind(this);
    this.loadMoreGlobalOffers = this.loadMoreGlobalOffers.bind(this);
  }

  loadGlobalOffers() {
    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_GLOBAL_GROUP_OFFERS,
      'pageID': this.pageID,
      'region': this.region,
      'brand': this.brand,
      'offset': 0,
      'length': this.firstLoad,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const offersCount = response.data['offers_count'];
          const offers = [...response.data['offers']];

          if (offersCount > 0) {
            this.setState({
              loading: false,
              offersCount: offersCount,
              allOffers: offers,
              loadMoreLoading: false,
              loadedAll: offersCount == offers.length,
            });
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreGlobalOffers() {
    const {
      allOffers,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_GLOBAL_GROUP_OFFERS,
        'pageID': this.pageID,
        'region': this.region,
        'brand': this.brand,
        'offset': allOffers.length,
        'length': this.loadMore,
      };

      // Send request
      axios.post(window.Rydges['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const offersCount = response.data['offers_count'];
            const offers = [
              ...allOffers,
              ...response.data['offers'],
            ];

            if (offersCount > 0) {
              this.setState({
                loading: false,
                allOffers: offers,
                loadMoreLoading: false,
                loadedAll: offersCount == offers.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  componentDidMount() {
    // Load global offers on first page load
    this.loadGlobalOffers();

    $(document).on(constants.EVENT_SUBMIT_CLICKED_SEARCH, (e, region, brand) => {
      if (this.region !== region || this.brand !== brand) {
        this.region = region;
        this.brand = brand;
        this.loadGlobalOffers();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.loading && !this.state.loading) ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading)
    ) {
      // Equal height for elements
      $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
    }
  }

  render() {
    const {
      loading,
      offersCount,
      allOffers,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            {
              ( loading || allOffers.length > 0 ) && (
                <div className="col-12">
                  <div className="results-count mb-4 skeleton-shine">
                    {
                      allOffers.length > 0 && (
                        'Showing ' + offersCount + ( offersCount > 1 ? ' results' : ' result' )
                      )
                    }
                  </div>
                </div>
              )
            }
            {
              !loading && allOffers.length > 0 && (
                allOffers.map((offer, i) => {
                  return (
                    <div className="col-12 col-md-6 col-lg-4" key={i}>
                      <div className="group-offer-card d-flex flex-column p-0">
                        <a href={offer['title_link']} target={offer['link_target']}>
                          <div className="card-image bg-center" style={{backgroundImage: `url(${offer['featured_image']})`}}>
                            {
                              offer['ribbon_label'].length > 0 && (
                                <div className="offer-ribbon">
                                  <span className="label">{offer['ribbon_label']}</span>
                                </div>
                              )
                            }
                          </div>
                        </a>
                        <div className="offer-details d-flex flex-column p-3 p-lg-0">
                          <div className="card-content p-4 balance-elements">
                            {
                              offer['title'].length > 0 && (
                                <div className="offer-name mb-2">
                                  <a href={offer['title_link']} target={offer['link_target']}>
                                    {offer['title']}
                                  </a>
                                </div>
                              )
                            }
                            {
                              offer['offer_title'].length > 0 && (
                                <div className="offer-title mb-2">
                                  <a href={offer['button_link']} target={offer['link_target']}>
                                    {offer['offer_title']}
                                  </a>
                                </div>
                              )
                            }
                            {
                              offer['inclusions'].length > 0 && (
                                <div className="offer-inclusions">
                                  <ul>
                                    {offer['inclusions'].map((inclusion, j) => (<li key={j}>{inclusion}</li>))}
                                  </ul>
                                </div>
                              )
                            }
                          </div>
                          <div className="card-book-details px-4 pb-4">
                            <a href={offer['button_link']} className="text-uppercase" target={offer['link_target']}>
                              View details
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )
            }
            {
              !loading && allOffers.length == 0 && (
                <div className="col-12">
                  <h2 className="h1 my-5 d-flex justify-content-center">No Offers found</h2>
                </div>
              )
            }
          </div>
          {
            (loading || loadMoreLoading) && (
              <GlobalGroupOffersSkeleton />
            )
          }
          {
            (loading || loadMoreLoading || allOffers.length > 0) && (
              <div className="row justify-content-center">
                <button className="btn btn-border-black btn-square btn-lg btn-border-black btn-load-more mt-5 text-uppercase load-more-btn" disabled={loading || loadMoreLoading || loadedAll } onClick={this.loadMoreGlobalOffers}>
                  {!loadedAll ? 'Load More' : 'That\'s All'}
                </button>
              </div>
            )
          }
        </div>
      </React.Fragment>
    );
  }
}

export default {
  init() {
    // JavaScript to be fired on all pages

    // Packages slider
    const groupOfferSlider = $('.section-global-group-offer-slider .slider');
    if (groupOfferSlider.length) {
      groupOfferSlider.slick({
        dots: false,
        infinite: false,
        arrows: true,
        appendArrows: '.slider-nav',
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    const body = $('body');

    const globalGroupOffersWrapper = $('#global-group-offers-wrapper');
    if (globalGroupOffersWrapper.length) {
      setTimeout(function() {
        ReactDOM.render(<AppGlobalGroupOffersPage />, globalGroupOffersWrapper[0]);
      }, 1000);
    }

    // Trigger search on input changes
    const searchGroupOffersForm = $('.search-group-offers');
    const regionsFilterSection = $('.section-group-offer-regions-filter');
    if (searchGroupOffersForm.length) {
      let timeout;
      const offerRegionInput = searchGroupOffersForm.find('input.region-search');
      const offerBrandsInput = searchGroupOffersForm.find('input.brands-search');
      const submitButton = searchGroupOffersForm.find('button[type="submit"]');
      const offerRegion = helpers.getParameterByName('region');
      const offerBrand = helpers.getParameterByName('brand');

      // Set url params to inputs
      if (offerRegion != null && offerRegion.length) {
        offerRegionInput.val(offerRegion);

        if (regionsFilterSection.length) {
          $('#group-offer-regions-filter').val(offerRegion).change();
        }
      }
      if (offerBrand != null && offerBrand.length) {
        offerBrandsInput.val(offerBrand);
      }

      searchGroupOffersForm.find('.where, .brand')
        .on('input', function() {
          const _this = $(this);

          if (_this.val().length === 0) {
            submitButton.prop('disabled', false);
          } else {
            submitButton.prop('disabled', true);
          }
        })
        .on('input_changed.rsd-ac', function() {
          submitButton.prop('disabled', false);
        });

      submitButton.on('click', function(e) {
        e.preventDefault();

        clearTimeout(timeout);

        const region = offerRegionInput.val();
        const brand = offerBrandsInput.val();
        const params = helpers.getParameters();

        if (region !== '') {
          params['region'] = region;
        } else {
          delete params['region'];
        }
        if (brand !== '') {
          params['brand'] = brand;
        } else {
          delete params['brand'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        if (regionsFilterSection.length) {
          regionsFilterSection.goToElement(undefined);
          $('#group-offer-regions-filter').val(region).change();
        }

        timeout = setTimeout(function() {
          $(document).trigger(constants.EVENT_SUBMIT_CLICKED_SEARCH, [region, brand]);
        }, 500);
      });
    }
    if (regionsFilterSection.length) {
      const regionsFilterSelect = $('#group-offer-regions-filter');

      regionsFilterSelect.on('select2:select', function() {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['region'] = selectedVal;
        } else {
          delete params['region'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        if (searchGroupOffersForm.length) {
          const offerRegionInput = searchGroupOffersForm.find('input.region-search');
          const offerBrandsInput = searchGroupOffersForm.find('input.brands-search');
          const brand = offerBrandsInput.val();

          offerRegionInput.val(selectedVal);
          offerRegionInput.keyup().trigger('input').trigger('blur');
          $(document).trigger(constants.EVENT_SUBMIT_CLICKED_SEARCH, [selectedVal, brand]);
        }
      });
    }

    // Enquire form modal
    const enquireForm = $('.group-offer-enquire-form');
    if (enquireForm.length) {
      $(document).on('click', '.enquire-form-trigger, .enquire-form-close', function(e) {
        e.preventDefault();
        body.toggleClass('enquire-form-mode');
        return false;
      });

      $(document).on('wpcf7invalid', function() {
        let requiredSelectField = enquireForm.find('select.wpcf7-validates-as-required');
        if (requiredSelectField.length) {
          requiredSelectField.each(function() {
            let _this = $(this);

            if (_this.val() === '' || _this.val() === null) {
              _this.addClass('wpcf7-not-valid');
            } else {
              _this.removeClass('wpcf7-not-valid');
            }
          });
        }
      });

      $(document).on('keydown', function(e) {
        if (body.hasClass('enquire-form-mode')) {
          if (e.key === 'Escape') {
            body.removeClass('enquire-form-mode');
            helpers.stopBodyScrolling(false);
          }
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptGroupOffer.js